import React from "react";
import PropTypes from 'prop-types';
import StyleableSection from "../../../components/StyleableSection";
import {FormattedMessage} from "react-intl";
import CardAmountField from "./CardAmountField";
import CurrencyFormatter from "currency-formatter";
import {Button, ButtonGroup, Typography, withStyles} from "@material-ui/core";
import CheckoutActions from "../../../constants/CheckoutActions";

const styles = (theme) => ({
  section: {
    width: '100%',
  },
  actionButton: {
    minWidth: 0,
    flexGrow: 1
  }
});

ActionSection.propTypes = {
  action: PropTypes.string.isRequired,
  section: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object
};

function ActionSection({
                         action,
                         section,
                         locale,
                         classes,
                         onChange
                       }) {

  locale = locale.replace('-', '_');

  return (
    <StyleableSection className={classes.section} section={section}>
      <ButtonGroup color="primary" style={{width: '100%'}}>
        <Button
          variant={action === CheckoutActions.NEW_CARD ? 'contained' : 'outlined'}
          fullWidth={false}
          color={action === CheckoutActions.NEW_CARD ? 'secondary' : 'default'}
          onClick={() => onChange(CheckoutActions.NEW_CARD)}
          className={classes.actionButton}
          data-test={'button-new-card-action'}
        >
          <FormattedMessage id={"button.new-card-action"}/>
        </Button>
        <Button
          variant={action === CheckoutActions.RELOAD_CARD ? 'contained' : 'outlined'}
          fullWidth={false}
          color={action === CheckoutActions.RELOAD_CARD ? 'secondary' : 'default'}
          onClick={() => onChange(CheckoutActions.RELOAD_CARD)}
          className={classes.actionButton}
          data-test={'button-reload-action'}
        >
          <FormattedMessage id={"button.reload-card-action"}/>
        </Button>
      </ButtonGroup>
    </StyleableSection>
  );

}

export default withStyles(styles)(ActionSection);
